/**
 * Environment config. API base URL is read from VITE_API_URL at build time
 * (.env, .env.production, or pipeline env). See docs/REPLACE-PRODUCTION-ENV.md.
 */

/**
 * API base URL for the app. Uses VITE_API_URL from .env (or pipeline at build time).
 * Fallback: in dev uses /api (proxy); otherwise https://localhost:7125/api.
 */
export function getEffectiveApiUrl(): string {
  const resolved = import.meta.env.VITE_API_URL;
  if (resolved) return resolved;
  return import.meta.env.DEV ? '/api' : 'https://localhost:7125/api';
}
